import angular from 'angular';
import additionalRecipients from 'report-subscriptions/components/additional-recipients/additional-recipients-module';
import reportSubscriptionsPageComponent from './report-subscriptions-page-component';

export default angular
  .module('reportSubscriptions', [additionalRecipients.name])
  .component('reportSubscriptionsPage', reportSubscriptionsPageComponent);



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/containers/page/report-subscriptions-page-module.js